import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CallbackResult, CallbackResultStatus } from '../../../../../../../../../utils';
import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { GuestPassEligibility } from '../../../../../../../../../models/customer';
import {
  OrganizationConfigService
} from '../../../../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-create-guest-pass-modal',
  templateUrl: './create-guest-pass-modal.component.html',
  styleUrls: ['./create-guest-pass-modal.component.css']
})
export class CreateGuestPassModalComponent {
  @Input() customerId: number;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public numPasses = 1;
  public eligibility = GuestPassEligibility.allCustomers;
  public availableStartingAt = '';
  public expiresAt = '';
  public name = '';

  public loadingSave = false;

  public serverError: number = null;
  public errorMessage = '';

  public readonly GuestPassEligibility = GuestPassEligibility;

  constructor(
    private customerService: CustomerService,
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {}

  public handleSave() {
    this.loadingSave = true;
    this.errorMessage = '';

    this.customerService
      .addGuestPasses(
        this.customerId,
        this.numPasses,
        this.eligibility,
        this.availableStartingAt,
        this.expiresAt,
        this.name
      )
      .then(() => {
        let successText: string;
        if (this.numPasses > 1) {
          successText = 'Guest passes created successfully.';
        } else {
          successText = 'Guest pass created successfully.';
        }
        this.savedCallback({
          text: successText,
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create guest passes.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }
}
